unit UReportShowForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UWebReportUtils,
  WEBLib.Buttons;

type
  TReportShowForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    htmlContainer: THTMLContainer;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FReport: TReport;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetReport(const Value: TReport);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Report: TReport read FReport write SetReport;
  protected procedure LoadDFMValues; override; end;

var
  ReportShowForm: TReportShowForm;

implementation

uses
  UEssentialHelper, WEBLib.LocalFiles;

{$R *.dfm}
{ TReportShowForm }

procedure TReportShowForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TReportShowForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TReportShowForm.SetReport(const Value: TReport);
var
  tFile: TTextFile;
  procedure HandleFileOpen(Sender: TObject);
  var
    s, h: string;
    o, e, d: TJsElement;
    p: Integer;
  begin
    if Sender is TTextFile then
    begin
      h := IntToStr(htmlContainer.Height - 8);
      s := (Sender as TTextFile).Text;
      if s <> '' then
      begin
        p := Pos('base64,', s);
        if p > 0 then
          Delete(s, 1, p + Length('base64,') - 1);
        s := 'data:application/pdf;base64,' + s;
        o := window.document.createElement('object');
        o.setAttribute('id', 'pdfObject');
        o.setAttribute('type', 'application/pdf');
        o.setAttribute('width', '100%');
        o.setAttribute('height', h);
        o.setAttribute('data', s);
        d := window.document.createElement('div');
        d.id := 'mainDiv';
        d.appendChild(o);
        e := window.document.getElementById('htmlContainer');
        e.appendChild(d);
      end;
    end;
  end;

begin
  FReport := Value;
  htmlContainer.HTML.Clear;
  tFile := TTextFile.Create(nil);
  tFile.OnFileOpen := HandleFileOpen;
  tFile.OpenFile(Self.Report.PdfPathname, Self.Report.PdfFilename);
end;

procedure TReportShowForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TReportShowForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Anzeige';
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Anzeige';
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
end;

procedure TReportShowForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  htmlContainer := THTMLContainer.Create('htmlContainer');

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  htmlContainer.BeforeLoadDFMValues;
  try
    Name := 'ReportShowForm';
    Width := 640;
    Height := 480;
    Caption := 'ReportShow';
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UReportShowForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Anzeige';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UReportShowForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    htmlContainer.SetParentComponent(Self);
    htmlContainer.Name := 'htmlContainer';
    htmlContainer.Left := 0;
    htmlContainer.Top := 64;
    htmlContainer.Width := 640;
    htmlContainer.Height := 392;
    htmlContainer.Align := alClient;
    htmlContainer.ChildOrder := 3;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    htmlContainer.AfterLoadDFMValues;
  end;
end;

end.
